var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInicio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "985D4C9C-444E-4856-8706-A6E4E50193AA")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Modelos-Originais",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "original",
    transform: "translate(-29.000000, -739.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7744845,26.2943578 C47.1007772,25.9442753 47.0692687,25.4077033 46.704133,25.0962008 L38.6597068,18.229408 C38.2945712,17.9179055 37.7091689,17.9244309 37.3517197,18.2441188 L29.2799509,25.4623107 C28.9225017,25.7819986 28.9049578,26.3178837 29.2411079,26.6587505 L29.4434786,26.8643582 C29.779218,27.205225 30.3219048,27.2458658 30.6548277,26.9548553 L31.2580673,26.4278426 L31.2580673,34.1433967 C31.2580673,34.6167752 31.6512497,35 32.1361414,35 L35.2825394,35 C35.7674311,35 36.1606135,34.6167752 36.1606135,34.1433967 L36.1606135,28.7456227 L40.1738786,28.7456227 L40.1738786,34.1433967 C40.1668962,34.6164318 40.5138426,34.9996566 40.9987343,34.9996566 L44.3331276,34.9996566 C44.8180193,34.9996566 45.2112017,34.6164318 45.2112017,34.1430533 L45.2112017,26.5364849 C45.2112017,26.5364849 45.3778392,26.6788992 45.5833783,26.8551425 C45.7885655,27.0310424 46.2195347,26.8900019 46.5458274,26.5395759 L46.7744845,26.2943578 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInicio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inicio.0811131a.svg";
export { ForwardRef as ReactComponent };